module.exports = __webpack_public_path__ + "img/feat_perm.212e106d.png";